/* ==========================================================================
   BIONIKA — méret-táblázat (mátrixos rendelés) modálban.

   Nyitó gomb: a vásárlási panelben (snippets/bnk-size-matrix-button.liquid).
   Tartalom: `/products/<handle>?section_id=bnk-size-matrix`, kérésre töltve —
   így a termékoldal nem hízik meg attól, hogy a lehetőség ott VAN.

   A kosárba tétel EGYETLEN `/cart/add.js` hívás, a `properties[Kompatibilitás]`
   értékkel együtt. (A Dawn quick-order-listje `/cart/update.js`-t hív, ami nem
   tud sortulajdonságot — emiatt nem használható itt.)
   ========================================================================== */
(function () {
  'use strict';

  var PROP = 'Kompatibilitás';
  var modal = null;
  var lastOpener = null;

  /* ---------- pénz ---------- */
  var nf = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0 });
  function money(cents) {
    return nf.format(Math.round(cents / 100)) + ' Ft';
  }

  /* ---------- modál váz ---------- */
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bnk-sm-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="bnk-sm-modal__backdrop" data-bnk-sm-close></div>' +
      '<div class="bnk-sm-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bnk-sm-title" tabindex="-1">' +
      '<div class="bnk-sm-modal__head">' +
      '<h2 class="bnk-sm-modal__title" id="bnk-sm-title">Méret-táblázat</h2>' +
      '<button type="button" class="bnk-sm-modal__close" aria-label="Bezárás" data-bnk-sm-close>&times;</button>' +
      '</div>' +
      '<div class="bnk-sm-modal__body" data-bnk-sm-body></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bnk-sm-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });
    return modal;
  }

  // A görgetés-zárat CSAK akkor oldjuk fel, ha mi tettük rá: a kollekció-oldali
  // quick-add modál is ugyanezt az osztályt használja, és záráskor nem szabad
  // alóla kirántani.
  var lockedByUs = false;

  function open() {
    ensureModal().removeAttribute('hidden');
    lockedByUs = !document.body.classList.contains('overflow-hidden');
    if (lockedByUs) document.body.classList.add('overflow-hidden');
    modal.querySelector('.bnk-sm-modal__dialog').focus();
  }

  function close() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    if (lockedByUs) document.body.classList.remove('overflow-hidden');
    lockedByUs = false;
    if (lastOpener) lastOpener.focus();
  }

  /* ---------- számolás ---------- */
  function panelOf(el) {
    return el.closest('[data-bnk-sm-panel]');
  }

  function rowsWithQty(panel) {
    var out = [];
    panel.querySelectorAll('[data-bnk-sm-row]').forEach(function (row) {
      var input = row.querySelector('[data-bnk-sm-qty]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (!qty || qty < 1) return;
      out.push({ row: row, id: parseInt(row.dataset.id, 10), qty: qty, price: parseInt(row.dataset.price, 10) });
    });
    return out;
  }

  function compatValue(panel) {
    var checked = panel.querySelector('[data-bnk-sm-compat] input:checked');
    return checked ? checked.value : '';
  }

  function recalc(panel) {
    var items = rowsWithQty(panel);
    var count = 0;
    var total = 0;

    panel.querySelectorAll('[data-bnk-sm-row]').forEach(function (row) {
      var cell = row.querySelector('[data-bnk-sm-sum]');
      if (cell) cell.textContent = '—';
      row.classList.remove('bnk-sm__row--picked');
    });

    items.forEach(function (it) {
      count += it.qty;
      total += it.qty * it.price;
      var cell = it.row.querySelector('[data-bnk-sm-sum]');
      if (cell) cell.textContent = money(it.qty * it.price);
      it.row.classList.add('bnk-sm__row--picked');
    });

    panel.querySelector('[data-bnk-sm-count]').textContent = count + ' db';
    panel.querySelector('[data-bnk-sm-total]').textContent = money(total);

    // BIONIKA minimum: készlet fölötti mennyiségből legalább 10 db (a Function a szerveren is ellenőrzi)
    var tooFew = [];
    items.forEach(function (it) {
      var stock = parseInt(it.row.dataset.stock || '999999', 10);
      var bad = it.row.dataset.min10 === '1' && it.qty > stock && it.qty < 10;
      it.row.classList.toggle('bnk-sm__row--min', bad);
      if (bad) tooFew.push(it.row.querySelector('.bnk-sm__name').firstChild.textContent.trim());
    });
    panel.querySelectorAll('.bnk-sm__row--min').forEach(function (row) {
      if (!items.some(function (it) { return it.row === row; })) row.classList.remove('bnk-sm__row--min');
    });
    var needCompat = panel.dataset.compatRequired === '1' && !compatValue(panel);
    var submit = panel.querySelector('[data-bnk-sm-submit]');
    submit.disabled = count === 0 || needCompat || tooFew.length > 0;
    if (tooFew.length) {
      setStatus(panel, (panel.dataset.minMsg || '').replace('{n}', tooFew.join(', ')), true);
      return;
    }
    setStatus(panel, count > 0 && needCompat ? 'Kérem válasszon kompatibilis márkát.' : '', count > 0 && needCompat);
  }

  function setStatus(panel, message, isError) {
    var el = panel.querySelector('.bnk-sm__status');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('bnk-sm__status--error', !!isError);
  }

  /* ---------- szűrés ---------- */
  function applyFilter(panel, term) {
    var needle = term.trim().toLowerCase();
    var visible = 0;
    panel.querySelectorAll('[data-bnk-sm-row]').forEach(function (row) {
      var hit = !needle || (row.dataset.search || '').indexOf(needle) !== -1;
      // A kiválasztott sorokat sosem rejtjük el — különben a vásárló nem látná,
      // mit tesz épp a kosárba.
      if (!hit && row.classList.contains('bnk-sm__row--picked')) hit = true;
      row.hidden = !hit;
      if (hit) visible += 1;
    });
    panel.querySelector('[data-bnk-sm-empty]').hidden = visible > 0;
  }

  /* ---------- kosárba ---------- */
  function submit(panel, button) {
    var items = rowsWithQty(panel);
    if (!items.length) return;
    var compat = compatValue(panel);
    var props = compat ? {} : null;
    if (compat) props[PROP] = compat;

    button.disabled = true;
    button.classList.add('bnk-sm__submit--loading');
    setStatus(panel, 'Kosárba helyezés…', false);

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = cart ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',') : '';

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items.map(function (it) {
          var line = { id: it.id, quantity: it.qty };
          if (props) line.properties = props;
          return line;
        }),
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        // Nullázás, hogy a modál újranyitva ne ismételje meg a rendelést.
        panel.querySelectorAll('[data-bnk-sm-qty]').forEach(function (i) {
          i.value = 0;
        });
        recalc(panel);
        setStatus(panel, items.length + ' méret a kosárba került.', false);
        close();
        if (cart && data.items && data.items.length) {
          cart.renderContents({ key: data.items[0].key, sections: data.sections });
        }
      })
      .catch(function (err) {
        setStatus(panel, (err && err.description) || 'A kosárba helyezés nem sikerült. Kérjük, próbálja újra.', true);
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('bnk-sm__submit--loading');
      });
  }

  /* ---------- betöltés ---------- */
  function load(opener) {
    lastOpener = opener;
    ensureModal();
    var body = modal.querySelector('[data-bnk-sm-body]');
    modal.querySelector('.bnk-sm-modal__title').textContent =
      opener.dataset.title || 'Méret-táblázat';

    if (body.dataset.loadedFor === opener.dataset.url) {
      open();
      return;
    }

    body.innerHTML = '<p class="bnk-sm__loading">Betöltés…</p>';
    open();

    fetch(opener.dataset.url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var panel = doc.querySelector('[data-bnk-sm-panel]');
        if (!panel) throw new Error('nincs panel');
        body.innerHTML = '';
        body.appendChild(panel);
        body.dataset.loadedFor = opener.dataset.url;
        prefillCompat(panel);
        recalc(panel);
      })
      .catch(function () {
        body.innerHTML =
          '<p class="bnk-sm__loading bnk-sm__status--error">A méret-táblázatot most nem sikerült betölteni.</p>';
      });
  }

  // A termékoldalon már választott (vagy a globális márkaválasztóból örökölt)
  // rendszert átvesszük, hogy ne kelljen kétszer megadni.
  function prefillCompat(panel) {
    var group = panel.querySelector('[data-bnk-sm-compat]');
    if (!group || group.querySelector('input:checked')) return;
    var onPage = document.querySelector('input[name="properties[' + PROP + ']"]:checked');
    var value = onPage ? onPage.value : (window.BionikaBrand && window.BionikaBrand.get && window.BionikaBrand.get()) || '';
    if (!value) return;
    group.querySelectorAll('input').forEach(function (input) {
      if (input.value === value) input.checked = true;
    });
  }

  /* ---------- események ---------- */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bnk-sm-open]');
    if (opener) {
      event.preventDefault();
      load(opener);
      return;
    }
    var step = event.target.closest('.bnk-sm__step');
    if (step) {
      var row = step.closest('[data-bnk-sm-row]');
      var input = row.querySelector('[data-bnk-sm-qty]');
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10);
      input.value = Math.max(0, next);
      recalc(panelOf(step));
      return;
    }
    var submitBtn = event.target.closest('[data-bnk-sm-submit]');
    if (submitBtn) submit(panelOf(submitBtn), submitBtn);
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-bnk-sm-qty]')) recalc(panelOf(event.target));
    if (event.target.matches('[data-bnk-sm-filter]')) applyFilter(panelOf(event.target), event.target.value);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-bnk-sm-compat]')) recalc(panelOf(event.target));
  });
})();
